import { Box, IconButton, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SimpleModalCompact from "../../common/ModalCompact/SimpleModalCompact";

/**
 * FullScreenReportsModal
 * Modal used to display reports in full screen with project context in the header.
 */
export default function FullScreenReportsModal({
  children,
  open,
  onClose,
  projectName = "Projekt",
}) {
  return (
    <SimpleModalCompact
      open={open}
      onClose={onClose}
      fullScreen
      draggable={false}
      title={
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            flexWrap: "wrap",
          }}
        >
          <IconButton
            onClick={onClose}
            aria-label="St�ng rapportvyn"
            size="small"
            edge="start"
            sx={{ color: "inherit" }}
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="span"
            sx={{ fontWeight: 500, color: "text.secondary", whiteSpace: "nowrap" }}
          >
            {projectName}
          </Typography>
          <Typography
            variant="h6"
            component="span"
            sx={{ fontWeight: 500, whiteSpace: "nowrap" }}
          >
            &gt; Rapporter
          </Typography>
        </Box>
      }
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </Box>
    </SimpleModalCompact>
  );
}
